import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "SiteCountdownArticleListContainer"
};
const _hoisted_2 = {
  class: "mb6 light leftCenter"
};
const _hoisted_3 = {
  class: "mr12"
};
const _hoisted_4 = {
  class: "light-more ml12 ft12"
};
const _hoisted_5 = {
  class: "rightCenter"
};
const _hoisted_6 = {
  class: "colFlex"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "light"
};
const _hoisted_9 = {
  class: "rightCenter"
};
const _hoisted_10 = {
  class: "light mr12 ft12"
};
const _hoisted_11 = {
  class: "leftCenter"
};
const _hoisted_12 = {
  key: 0,
  src: "https://cdn.waityou.online/736652c6-a95c-f436-1dc5-4b44507142ca.png",
  class: "sqr16 mr6"
};
const _hoisted_13 = {
  key: 1,
  src: "https://cdn.waityou.online/53543ff1-c94a-8357-9be6-3cbdcf9315b9.png",
  class: "sqr16 mr6"
};
const _hoisted_14 = {
  key: 2,
  src: "https://cdn.waityou.online/f20f781c-4f06-dd03-eb6d-645acc31629d.svg",
  class: "sqr16 mr6"
};
const _hoisted_15 = {
  class: "leftCenter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_timeline = _resolveComponent("el-timeline");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_timeline, {
    style: {
      "max-width": "600px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_timeline_item, {
      timestamp: "NEW",
      placement: "top"
    }, {
      default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
        "btn-id": 10,
        "btn-name": "新增节点",
        onFresh: $options.init,
        "init-data": {
          siteId: $props.siteId
        }
      }, null, 8, ["onFresh", "init-data"])]),
      _: 1
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, cdd => {
      return _openBlock(), _createBlock(_component_el_timeline_item, {
        key: `cdd_${cdd.id}`,
        timestamp: cdd.date.substring(0, 7) + '  ' + cdd.title,
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "排序:", -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(cdd.sortIndex), 1), _createVNode(_component_ButtonDialog, {
          "btn-id": 11,
          "bind-id": cdd.id,
          style: 1,
          size: "small",
          "btn-name": "编辑",
          onFresh: $options.init,
          "init-data": {
            siteId: $props.siteId
          }
        }, null, 8, ["bind-id", "onFresh", "init-data"]), _createVNode(_component_el_popconfirm, {
          title: "确定删除吗",
          onConfirm: $event => $options.deleteCountdownDate(cdd.id),
          class: "ml12"
        }, {
          reference: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("span", {
            style: {
              "cursor": "pointer",
              "margin-left": "10px",
              "color": "#F4333C"
            }
          }, "删除", -1)])),
          _: 2
        }, 1032, ["onConfirm"]), _createElementVNode("span", _hoisted_4, _toDisplayString(cdd.creatorName) + " @ " + _toDisplayString(cdd.createdTime), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          type: "warning",
          size: "small",
          onClick: $event => $options.addPage(cdd.id)
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("新增文章")])),
          _: 2
        }, 1032, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cdd.pages, a => {
          return _openBlock(), _createBlock(_component_el_card, {
            class: "mt12",
            key: `page_${a.id}`
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
              class: "boldFont ptr ft18",
              onClick: $event => $options.previewHtml(a),
              style: {
                "color": "#009FFF"
              }
            }, _toDisplayString(a.title), 9, _hoisted_7), _createElementVNode("span", _hoisted_8, _toDisplayString(a.description), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(a.createdTime), 1), _createVNode(_component_el_popconfirm, {
              title: "确定删除吗",
              onConfirm: $event => $options.deleteCountdownArticle(cdd.id, a.id),
              class: "ml12"
            }, {
              reference: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("span", {
                style: {
                  "cursor": "pointer",
                  "margin-left": "10px",
                  "color": "#F4333C"
                }
              }, "删除", -1)])),
              _: 2
            }, 1032, ["onConfirm"])])])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 2
      }, 1032, ["timestamp"]);
    }), 128))]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    width: "1200px",
    title: "添加文章到倒计时中",
    "visible-control": $data.addPageVisible,
    onClose: $options.init
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      "table-id": 12,
      "init-query": {
        addBtn: false,
        siteId: $props.siteId,
        refId: $props.siteId
      }
    }, {
      nav: _withCtx(data => [_createElementVNode("div", _hoisted_11, [data.data.hotSearchTag == 'HOT' ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NEW' ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NONE' ? (_openBlock(), _createElementBlock("img", _hoisted_14)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(data?.data?.nav?.label) + " / " + _toDisplayString(data?.data?.subNav?.label), 1)])]),
      title: _withCtx(data => [_createElementVNode("div", _hoisted_15, [data.data.schoolId != null ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "item",
        effect: "dark",
        content: data.data.schoolName,
        placement: "top"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("img", {
          src: "https://cdn.waityou.online/439a2635-e911-3559-3581-b16eb0f557e0.svg",
          class: "sqr16 mr12"
        }, null, -1)])),
        _: 2
      }, 1032, ["content"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(data.rowData), 1)])]),
      operate: _withCtx(data => [_createVNode(_component_el_button, {
        onClick: $event => $options.choose(data.rowId)
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("选择")])),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    }, 8, ["init-query"])]),
    _: 1
  }, 8, ["visible-control", "onClose"])], 64);
}